<template>
    <modal
        id="payment-delay-notice-modal"
        :centered="true"
        :title="title"
        :show="show"
        :close="close"
        :closeable="closeable"
        size="modal-lg"
    >
        <div class="modal-body">
            <p class="mb-0" v-html="text"></p>
        </div>
        <div class="modal-footer justify-content-center">
            <button
                type="button"
                class="btn btn-secondary"
                @click="onActionClick(false)"
                v-html="$t('generic.no')"
            ></button>
            <button
                type="button"
                class="btn btn-primary"
                @click="onActionClick(true)"
                v-html="$t('shop.continue')"
            ></button>
        </div>
    </modal>
</template>

<script>
export default {
    name: 'PaymentNoticeModal',
    emits: ['close', 'reset'],
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        close: {
            type: Boolean,
            default: false,
        },
        closeable: {
            type: Boolean,
            default: true,
        },
        title: {
            type: String,
            default: '',
        },
        text: {
            type: String,
            default: '',
        },
    },
    methods: {
        /**
         * Handle the callback of delay modal notice, to handle the selected action.
         *
         * @param {boolean} confirmed
         *
         * @returns {void}
         * */
        onActionClick(confirmed) {
            // Switch the confirmation status of modal, because both will be handled
            // nearly the same. But in the case of canceled process, we will reset the
            // form values to prevent a submitting of this field.
            let callback = () => {};

            switch (confirmed) {
                case true:
                    callback = () => {
                        this.$emit('continue');
                    };

                    break;

                case false:
                default:
                    this.method = null;
                    this.subMethod = null;

                    break;
            }

            this.$emit('close');

            this.$nextTick(() => {
                this.$emit('reset', {closeable: false, close: false});
                callback();
            });
        },
    },
};
</script>

<style scoped lang="scss">

</style>
